/* eslint semi: ["error", "never"] */

$(function() {
  require('web-animations-js')
  const AnimatedModule = require('_module/animatedModule')
  const AnimationsPlayer = require('_module/animationsPlayer')

  const LAST_FRAME_TIMING = 0.99

  const PROPERTIES_NEEDS_PERSPECTIVE = [
    'translateZ',
    'translate3d',
    'rotateX',
    'rotateY',
  ]

  class AnimatedStylesModule extends AnimatedModule {
    initAnimation() {
      this.setId()
      this.collectKeyframes()
      this.check3d()
      this.bindEvents()

      this.player = AnimationsPlayer.for(this.$el, this.keyframes)
    }

    initPlayer() {
      this.player.init()
    }

    disposePlayer() {
      this.player.dispose()
    }

    bindEvents() {
      this.$document = $(document)

      this.$spread.on('spreadVisualized', this.initPlayer.bind(this))
      this.$spread.on('spreadDevisualized', this.disposePlayer.bind(this))

      // Still used by progress bar module in book-text:
      // * https://github.com/artgorbunov/book-text/blob/21dafa56805e8f812c4f98316c4b90756d3b18ee/modules/progressbar/progressbar.js#L55
      // * https://github.com/artgorbunov/book-text/blob/21dafa56805e8f812c4f98316c4b90756d3b18ee/modules/progressbar/progressbar.js#L64
      // * https://github.com/artgorbunov/book-text/blob/21dafa56805e8f812c4f98316c4b90756d3b18ee/modules/progressbar/progressbar.js#L86
      this.$el.on('seekStart', () => { this.isLocked = true })
      this.$el.on('seek', (_, progress) => this.seek(progress))
      this.$el.on('seekStop', () => { this.isLocked = false })
    }

    setId() {
      this.id = this.$el.attr('id')

      if (!this.id) {
        this.id = 'animation_' + __.generateID(10)
        this.$el.attr('id', this.id)
      }
    }

    collectKeyframes() {
      this.keyframes = []
      this.cssStrings = ''

      const attrbutesSearchPattern = new RegExp('(%|from|to)$')

      for (let attribute in this.animation) {
        if (attrbutesSearchPattern.test(attribute)) {
          let cssString = this.animation[attribute]
          const keyframe = {}

          cssString.split(';')
            .filter(declaration => declaration.trim().length)
            .forEach(declaration => {
              const [property, value] = declaration.split(':').map(part => part.trim())
              keyframe[property] = value
            })

          keyframe.offset = this.parseOffset(attribute)
          this.keyframes.push(keyframe)

          // HACK: work around never hitting 100% animation
          if (keyframe.offset >= 1) {
            this.keyframes.push({ ...keyframe, offset: LAST_FRAME_TIMING })
          }

          this.cssStrings += cssString
        }
      }

      this.keyframes.sort((a, b) => a.offset - b.offset)
    }

    check3d() {
      PROPERTIES_NEEDS_PERSPECTIVE.every((prop) => {
        if (this.cssStrings.indexOf(prop) > -1) {
          this.$el.parent().addClass('is__3dContainer')
          return false
        }
        return true
      })
    }

    seek(progress) {
      if (progress >= 1) progress = LAST_FRAME_TIMING

      this.player.seek(progress)
    }

    draw(progress) {
      if (this.isLocked) return

      this.seek(progress)
    }

    parseOffset(attribute) {
      const parsedNumber = parseFloat(attribute, 10) / 100

      switch (attribute) {
        case 'from':
          return 0

        case 'to':
          return 1

        default:
          return isNaN(parsedNumber) ? 0 : parsedNumber
      }
    }
  }

  $('.js__animatedStyles').each(function() {
    new AnimatedStylesModule($(this))
  })
})
